

<template>
  <div class="col-md-6">
    <div class="projecten__inner">
      <div class="projecten__inner--img">
        <a @click="goToWonenObject" class="plaats">
          <img
            v-if="product.Image != ''"
            @error="usePlaceHolderImage()"
            :src="product.Image"
            alt="Image"
            class="img-responsive"
          />
        </a>
      </div>
      <div class="projecten__inner--info">
        <h3>{{ product.Title }}</h3>
        <a @click="goToWonenObject" class="plaats">
          {{ viewProjectInfo() }}
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 64 26.7"
            style="overflow: visible; enable-background: new 0 0 64 26.7"
            xml:space="preserve"
          >
            <path
              d="M62.6,9.7l-7.5-8.8c-1.1-1.1-2.7-1.3-3.7-0.3c-1.1,1.1-1.3,2.7-0.3,3.7l5.3,6.4H2.7c-1.6,0-2.7,1.1-2.7,2.7s1.1,2.7,2.7,2.7
          h53.8l-5.3,6.4c-1.1,1.1-0.8,2.9,0.3,3.7c0.5,0.5,1.1,0.5,1.6,0.5c0.8,0,1.6-0.3,2.1-1.1l7.5-8.8C64.5,15.1,64.5,11.9,62.6,9.7z"
            ></path>
          </svg>
        </a>
      </div>
    </div>
  </div>
  <!-- <div class="productCard" ref="productCard" v-observe-visibility="visibilityChanged">
        <b-card :img-src="product.Images[1]" img-alt="Image" img-top tag="article" style>
          <div class="infoDiv" v-bind:style="{ padding: infoDivPadding - 0.5 + 'rem' }">
            <div v-bind:style="{ height: fontSizeStraatHuisnummer * 3.1 + 'px' }" class="straatHuisnummerSingleLineCenterer">
              <div v-bind:style="{ fontSize: fontSizeStraatHuisnummer + 'px' }" class="straatHuisnummer">
                 {{product.Title}}
              </div>
              <a @click="goToWonenObject" v-bind:style="{ fontSize: fontSizePlaats + 'px' }" class="plaats">Bekijk project →</a>
            </div>
          </div>
        </b-card>
    </div> -->
</template>

<!-- #region script -->
<script>
export default {
  name: "ProductCard",
  props: {
    product: {},
  },
  data: function () {
    return {
      cardWidth: 0,
      windowHeight: 0,
    };
  },
  computed: {
    fontSizePlaats: function () {
      return this.calcRangeValue(20, 11, 17);
    },

    fontSizeStraatHuisnummer: function () {
      return this.calcRangeValue(15, 11, 21);
    },
    fontSizePrijs: function () {
      return this.calcRangeValue(20, 10, 20);
    },
    fontSizeSpec: function () {
      return this.calcRangeValue(20, 10, 15);
    },
    infoDivPadding: function () {
      return this.calcRangeValue(200, 0, 2);
    },
    specsDivHeight: function () {
      return this.calcRangeValue(4.45, 35, 80);
    },
    imageHeight: function () {
      if (this.cardWidth < 200) {
        return 14;
      } else if (this.cardWidth < 301) {
        return 20;
      } else if (this.cardWidth < 370) {
        return 30;
      } else {
        return 35;
      }
    },
  },

  methods: {
    viewProjectInfo() {
      let url = this.$store.state.miscData.miscData.OverviewPageURL;
      if (url.startsWith("/en/")) {
        // add the language to the querystring
        return "View project";
      } else {
        return "Bekijk project";
      }
    },
    usePlaceHolderImage() {
      this.product.Image = this.$store.state.miscData.miscData.PlaceholderImage;
    },
    visibilityChanged() {
      // de card is al gemount voordat je 'm ziet dus dan klopt de CardWidth nog niet. Zodra de visibility changet dan veranderd ook de width.
      this.getCardWidth();
    },
    goToWonenObject(event) {
      event.preventDefault();
      // We use localStorage to store the state between the home page and the productOverviewPage because we can't use the app as a true single page app on the home page(cannot keep the state). because the app does not cover the whole page. Another reason is that we want to display the values of selectedPlaceinput and selectedStraal. Another reason is that it would be inefficient to do another call to the backend for the same data.
      this.$store.commit("routedByRedirection", true);
      localStorage.setItem("state", JSON.stringify(this.$store.state));
      window.location.href = this.product.Url;
    },

    getCardWidth(event) {
      // Om errors te vermijden als productCard nog niet beschikbaar is.
      try {
        this.cardWidth = this.$refs.productCard.clientWidth;
      } catch {}
    },
    calcRangeValue(factor, min, max) {
      let fontSize = this.cardWidth / factor;
      if (fontSize > max) {
        return max;
      } else if (fontSize < min) {
        return min;
      } else {
        return fontSize;
      }
    },
  },

  mounted() {
    this.getCardWidth(); //init
    this.$nextTick(function () {
      window.addEventListener("resize", this.getCardWidth);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
  },
};
</script>
<!-- #endregion -->

<style lang="scss">
.img-responsive {
  display: block;
  width: 100%;
  height: auto;
}
.productCard {
  * {
    overflow: hidden;
  }
  .card-body {
    padding: 0px !important;
  }
  // :hover {
  //   background-color: rgb(248, 248, 255);
  // }

  .infoDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .plaats {
      /* padding: 0.8em 0em 0.8em 0em; */
      display: flex;
      overflow: hidden;
      cursor: pointer;
    }
    .straatHuisnummerSingleLineCenterer {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .straatHuisnummer {
        display: flex;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        font-weight: 500;
        /* height: 60px; */
        overflow: hidden;
      }
    }

    .prijs {
      display: flex;
      color: #97be0e;
      overflow: hidden;
      /* padding: 0.8em 0em 0.8em 0em; */
      font-weight: 600;
    }
  }

  .hr {
    height: 1px;
    width: 97%;
    background-color: #e3e4e4;
    margin: auto;
  }

  .specsDiv {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .spec {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 50%;

      .oppervlakteImage {
        height: calc(50%);
      }

      .amount {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 0.3em;
      }
    }
  }

  .verticalHr {
    width: 1px;
    background-color: #e3e4e4;
    height: 50%;
  }
}
</style>
